/** Select one upload's avatar/full pair without borrowing artwork from another upload. */
export function pcPictureRow<T>(list: readonly T[] | null | undefined, want: 'avatar' | 'full'): T | null {
    if (!Array.isArray(list) || list.length === 0) return null;
    const field = (value: T, key: string): unknown => {
        const row = value as Record<string, unknown> | null;
        const raw = row?.[key] ?? (key === 'picture_thumbnail' ? row?.pic_thumbnail : undefined);
        return Array.isArray(raw) ? raw[0] : raw;
    };
    const isCrop = (row: T): boolean => Number(field(row, 'picture_thumbnail') ?? 0) === 1;
    const anchor = list.find(row => Number(field(row, 'primary_picture') ?? 0) === 1) ?? list[0]!;
    const wantCrop = want === 'avatar';
    if (isCrop(anchor) === wantCrop) return anchor;
    const number = field(anchor, 'picture_number');
    // Older malformed galleries without an upload identity cannot safely be paired.
    if (number === undefined || number === null || number === '') return anchor;
    return list.find(row => isCrop(row) === wantCrop
        && String(field(row, 'picture_number')) === String(number)) ?? anchor;
}
